import { Modal, Table } from "antd";
import dayjs from "dayjs";

const ShowUnsatisfiedQueryDetailsModal = ({
  isModalOpen = false,
  unSatisfiedQueriesList = {},
  setIsModalOpen = () => {}
}) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Title",
      key: "title",
      render: (row) => (
        <u>
          <a href={row.threadLink} target="_blank" rel="noreferrer">
            {row.title}
          </a>
        </u>
      )
    },
    {
      title: "Resolved Time",
      dataIndex: "resolvedTime",
      key: "resolvedTime",
      render: (resolvedTime) => dayjs(resolvedTime).format("DD MMM YYYY | HH:mm")
    },
    {
      title: "Mentor",
      dataIndex: "mentor",
      key: "mentor"
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason"
    },
    {
      title: "Student Email",
      dataIndex: "studentEmail",
      key: "studentEmail"
    }
  ];

  return (
    <Modal
      title="Unsatisfied Query Details"
      open={isModalOpen}
      footer={null}
      onOk={handleOk}
      onCancel={handleCancel}
      width="90vw"
      bodyStyle={{
        overflowX: "auto",
        padding: 16
      }}
    >
      <Table
        columns={columns}
        dataSource={unSatisfiedQueriesList}
        bordered
        scroll={{ x: "max-content" }}
      />
    </Modal>
  );
};
export default ShowUnsatisfiedQueryDetailsModal;
